import type {
  DashboardGridType,
  DashboardStoreType,
} from '../state/dashboard/initials';

/** Reads one dashboard grid record from a runtime/dashboard store snapshot. */
export const getDashboardAtKey = (
  id: number,
  type: 'grids' | 'reports',
  dashboardSlice: DashboardStoreType
): DashboardGridType | undefined => dashboardSlice[type]?.[id];

/** Finds which grid contains a widget with the given dashboard element id. */
export const findGridIdAndTypeByElementId = (
  elementId: number,
  dashboardSlice: DashboardStoreType
): { id: number; type: 'grids' | 'reports' } | undefined => {
  for (const type of ['grids', 'reports'] as const) {
    for (const [gridId, dashboard] of Object.entries(
      dashboardSlice[type] ?? {}
    )) {
      const hasElement = Object.values(dashboard.widgets ?? {}).some(
        (widget) => widget.dashboardElementId === elementId
      );
      if (hasElement) {
        return { id: Number(gridId), type };
      }
    }
  }

  return undefined;
};
